import React from 'react';
import { Provider } from './src/components/industry-context';

export default (
  { element } : {element: React.ReactNode },
) => <Provider>{element}</Provider>;
